export class ServiceNowIntegration {
  constructor(private readonly instanceUrl: string, private readonly userID: string) {}

  getInstanceUrl() {
    return this.instanceUrl;
  }

  getUserID() {
    return this.userID;
  }
}
